import type { PaymentProviderResponse } from "@/api/hooks/usePaymentProvider.ts";

export const COUNTRY_ARRAY_MODEL = ["CZ", "SK", "PL", "DE", "AT", "HU"];

export function sortCountries(countries: string[]): string[] {
  return countries.sort((a, b) => {
    const indexA = COUNTRY_ARRAY_MODEL.indexOf(a);
    const indexB = COUNTRY_ARRAY_MODEL.indexOf(b);
    return indexA !== -1 && indexB !== -1 ? indexA - indexB : indexA === -1 ? 1 : -1;
  });
}

export function sortCountriesByCountryAndName(
  countries: PaymentProviderResponse["paymentProviders"],
): PaymentProviderResponse["paymentProviders"] {
  if (!countries) return [];
  return [...countries].sort((a, b) => {
    const indexA = COUNTRY_ARRAY_MODEL.indexOf(a.countryCode ?? "");
    const indexB = COUNTRY_ARRAY_MODEL.indexOf(b.countryCode ?? "");

    const isKnownA = indexA !== -1;
    const isKnownB = indexB !== -1;

    if (isKnownA && isKnownB) {
      if (indexA !== indexB) return indexA - indexB;
      return (a.name ?? "").localeCompare(b.name ?? "");
    }

    if (isKnownA) return -1;
    if (isKnownB) return 1;

    // Both unknown – sort by countryCode, then by name
    const countryCompare = (a.countryCode ?? "").localeCompare(b.countryCode ?? "");
    return countryCompare !== 0 ? countryCompare : (a.name ?? "").localeCompare(b.name ?? "");
  });
}
